module.exports = __webpack_public_path__ + "static/media/thermometer-empty.3c796555.svg";